<template lang="pug">
div.container
  section.row
    .page-header
      h1 Styleguide
      div.description click on any logo to download the packaged files
</template>

<script>

export default {
  name: 'styleguide',
  components: {},
  data: function () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/scenes/pages/styleguide.vue